<template>
  <div class="info-column spacey-4">
    <div v-if="title" class="text text-grey text-sm">
      {{ title }}
    </div>
    <div v-if="value" class="text text-black text-sm">
      {{ value }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseInfoColumn',
    props: {
      title: {
        type: String,
        required: true,
      },
      value: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  .info-column {
    display: flex;
    flex-direction: column;
  }
</style>
